(function () {
  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-shop-tab]'));
    if (!tabs.length) return;

    var sections = [];
    tabs.forEach(function (btn) {
      var id = btn.getAttribute('data-shop-tab');
      var el = document.getElementById('shop-rail-' + id);
      if (el) sections.push(el);
    });

    var scrollLock = false;
    var activeId = '';

    function setActive(id, scrollTab) {
      if (!id || id === activeId) return;
      activeId = id;
      tabs.forEach(function (btn) {
        var on = btn.getAttribute('data-shop-tab') === id;
        btn.classList.toggle('shop-hub__tab--active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && scrollTab) {
          btn.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        }
      });
    }

    tabs.forEach(function (btn) {
      if (btn.classList.contains('shop-hub__tab--active')) {
        activeId = btn.getAttribute('data-shop-tab') || '';
      }
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-shop-tab');
        var el = document.getElementById('shop-rail-' + id);
        if (!el) return;
        scrollLock = true;
        setActive(id, true);
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () {
          scrollLock = false;
        }, 700);
      });
    });

    if (!sections.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        if (scrollLock) return;
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return b.intersectionRatio - a.intersectionRatio;
          })[0];
        if (!visible || !visible.target.id) return;
        setActive(visible.target.id.replace(/^shop-rail-/, ''), true);
      },
      {
        rootMargin: '-35% 0px -45% 0px',
        threshold: [0.15, 0.35, 0.55],
      },
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  document.querySelectorAll('[data-shop-hub]').forEach(init);
})();
